<template>
  <div class="navigation">
    <nav class="drawer-nav">
      <ul class="drawer-menu">
        <li :class="{ 'now-area': isSelect(0) }">
          <router-link :to="{ name: 'home' }">
            <p>HOME</p>
          </router-link>
        </li>
        <li
          v-for="(page, index) in pages"
          :key="index"
          :class="{ 'now-area': isSelect(index + 1) }"
        >
          <router-link :to="{ name: 'pages', params: { id: index + 1 } }">
            <p>{{ page }}</p>
          </router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import pageLists from '@/mixins/PageLists.js';

export default {
  name: 'Navigation',
  mixins: [pageLists],
  data() {
    return {
      currentId: 0
    };
  },
  mounted: function() {
    $(function() {
      $('.drawer').drawer();
      $('body').fadeMover();
    });
  },
  created() {
    this.currentId = Number(this.$route.params.id);
  },
  methods: {
    isSelect: function(v) {
      if (v == 0 && (isNaN(this.currentId) || this.currentId == undefined)) {
        return true;
      }
      if (v == this.currentId) {
        return true;
      }
    }
  },
  watch: {
    $route: function(to, from) {
      this.currentId = to.params.id;
    }
  }
};
</script>

<style scoped>
ul {
  word-break: keep-all;
}

nav > ul > li > a {
  display: table;
  width: 100%;
  height: 100%;
}

nav > ul > li > a > p {
  display: table-cell;
  padding: 0 8px;
  height: 100%;
  vertical-align: middle;
  font-size: 11.5px;
}
</style>
